import { render } from "./AposLoading.vue?vue&type=template&id=47a6d564&scoped=true"
import script from "./AposLoading.vue?vue&type=script&lang=js"
export * from "./AposLoading.vue?vue&type=script&lang=js"

import "./AposLoading.vue?vue&type=style&index=0&id=47a6d564&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a6d564"],['__file',"ui/ui/apos/components/AposLoading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47a6d564"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47a6d564', __exports__)) {
    api.reload('47a6d564', __exports__)
  }
  
  module.hot.accept("./AposLoading.vue?vue&type=template&id=47a6d564&scoped=true", () => {
    api.rerender('47a6d564', render)
  })

}


export default __exports__